/* Shared presentation; native Impact variants, cart and product identity remain authoritative. */
if (!customElements.get('smd-case-configurator')) {
  customElements.define('smd-case-configurator', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.formId = this.dataset.formId;
      const data = JSON.parse(this.querySelector('[data-case-variants]').textContent);
      this.variants = data.variants;
      this.money = data.money;
      this.nativeCombined=this.dataset.nativeCombined==='true';
      this.optionNames=data.options;
      this.caseIndex=this.optionNames.indexOf('Case Type');
      this.colorIndex=this.optionNames.indexOf('Color');
      if(this.dataset.previewThemeId){const previewURL=new URL(location.href);previewURL.searchParams.set('preview_theme_id',this.dataset.previewThemeId);history.replaceState({path:previewURL.toString()},'',previewURL);}
      if(this.nativeCombined)customElements.whenDefined('media-carousel').then(()=>{if(this.isConnected)this.update();});
      // Default to the first native size; explicit variant/device links remain authoritative.
      this.chosen = !!this.variant;
      this.pending = false;
      this.requested = null;
      this.selectedVariantId = this.variant?.id || null;
      this.failed = false;
      this.adding = false;
      this.addUncertain = false;
      this.moneyText = value => new DOMParser().parseFromString(String(value || ''),'text/html').body.textContent;
      this.normalize = value => String(value || '').toLowerCase().replace(/\s+/g, '');
      const deviceHint = new URL(location.href).searchParams.get('smd_device');
      const first = this.variants.find(v => String(v.id) === String(this.form?.querySelector('[name="id"]')?.value));
      if (deviceHint && (!first || this.normalize(first.option1) !== this.normalize(deviceHint))) {
        this.chosen = false;
        this.message(`${deviceHint} is not available for this case. Choose another device.`, true);
      }
      window.addEventListener('change', e => {
        if (!e.target.matches(`input[data-option-position][form="${this.formId}"]`)) return;
        if(this.nativeCombined){e.stopImmediatePropagation();this.selectNative(e);return;}
        this.chosen = true;
        this.pending = true;
        this.failed = false;
        this.requested = this.selectedOptions();
        this.message('Updating your case…');
        clearTimeout(this.pendingTimer);
        this.pendingTimer=setTimeout(()=>{if(this.pending){this.failed=true;this.pending=false;this.message('Could not update your case. Choose your device again or reload the page.',true);this.update();}},12000);
        this.update();
      }, {capture:true,signal:this.abort.signal});
      this.addEventListener('variant:change', e => {
        if (e.target.getAttribute('id') !== this.formId) return;
        const v = e.detail.variant;
        if (this.requested && (!v || v.options.some((o,i) => o !== this.requested[i]))) {
          this.pending=false;this.failed=true;
          this.message('Choose your device again to confirm the latest selection.',true);this.update();return;
        }
        clearTimeout(this.pendingTimer);
        this.pending = false;
        this.failed = false;
        this.message('');
        this.update();
      }, {signal:this.abort.signal});
      this.addEventListener('submit', e => {
        if (e.target.getAttribute('id') !== this.formId) return;
        if (!this.canBuy()) { e.preventDefault();e.stopImmediatePropagation();this.edit();return; }
        this.adding = true;this.update();
        clearTimeout(this.addTimer);
        this.addTimer=setTimeout(()=>{if(this.adding){this.adding=false;this.addUncertain=true;this.message('We could not confirm your cart. Check your cart before trying again.',true);this.update();}},20000);
      }, {capture:true,signal:this.abort.signal});
      this.addEventListener('click', e => {
        const link = e.target.closest('[data-case-link]');
        if (link && this.pending) { e.preventDefault();return; }
        if (e.target.closest('[data-case-edit]')) this.edit();
        if (e.target.closest('[data-case-submit]')) {
          if (!this.canBuy()) {this.edit();return;}
          this.form.requestSubmit(this.form.querySelector('[type="submit"]'));
        }
      }, {signal:this.abort.signal});
      this.addEventListener('variant:add', e => {if(e.target.getAttribute('id')!==this.formId)return;clearTimeout(this.addTimer);this.adding=false;this.addUncertain=false;this.message('');this.update();}, {signal:this.abort.signal});
      this.addEventListener('cart:error', e => {if(e.target.getAttribute('id')!==this.formId)return;clearTimeout(this.addTimer);this.adding=false;this.addUncertain=false;this.update();}, {signal:this.abort.signal});
      this.observer = new MutationObserver(() => {
        if (this.pending && this.requested) {
          const native = this.querySelector('variant-picker');
          const v = native?.selectedVariant;
          if (v && v.options.every((o,i) => o === this.requested[i]) && String(this.form?.querySelector('[name="id"]')?.value) === String(v.id)) {
            this.pending=false;this.failed=false;this.message('');
          }
        }
        this.update();
      });
      this.observer.observe(this.querySelector('product-rerender'), {childList:true,subtree:true});
      this.watch = new IntersectionObserver(entries => {
        const above = entries[0].boundingClientRect.bottom < 0;
        this.querySelector('[data-case-sticky]').classList.toggle('is-visible', above);
      }, {threshold:0});
      const incoming = new URL(location.href).searchParams;
      if (this.nativeCombined && !incoming.has('variant') && !incoming.has('smd_device')) {
        const firstDevice = this.querySelector('input[data-option-position="1"]');
        if (firstDevice) { firstDevice.checked = true; this.selectNative({target:firstDevice}); }
      }
      this.update();
      // Related products load asynchronously; update real URLs for keyboard and new-tab use too.
      this.recommendationData = new WeakMap();
      this.recommendationObserver = new MutationObserver(() => this.updateRecommendations());
      document.querySelectorAll('[data-smd-recommendations]').forEach(root => this.recommendationObserver.observe(root, {childList:true, subtree:true}));
      document.addEventListener('click', e => {
        if (!e.target.closest('[data-smd-recommendations] a[href]')) return;
        if (this.pending || !this.chosen || this.failed) {e.preventDefault();this.edit();return;}
        this.updateRecommendations();
      }, {capture:true, signal:this.abort.signal});
      this.updateRecommendations();
      if (new URL(location.href).searchParams.get('smd_selection_changed') === '1' && this.chosen) {
        this.message('Your phone is kept. This design has different case or color options; please check your selection.');
      }
      const updateSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {this.stickyFrame = null;this.updateStickyVisibility();});
      };
      window.addEventListener('scroll', updateSticky, {passive:true, signal:this.abort.signal});
      window.addEventListener('resize', updateSticky, {passive:true, signal:this.abort.signal});
      window.addEventListener('pageshow', updateSticky, {signal:this.abort.signal});
      this.updateStickyVisibility();
      this.dataset.configuratorReady='true';
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.watch?.disconnect();this.recommendationObserver?.disconnect();cancelAnimationFrame(this.stickyFrame);clearTimeout(this.pendingTimer);clearTimeout(this.addTimer);}
    updateStickyVisibility() {
      const button=this.querySelector('.product-info__buy-buttons');
      const sticky=this.querySelector('[data-case-sticky]');
      if(button && sticky)sticky.classList.toggle('is-visible',button.getBoundingClientRect().bottom<0);
    }
    recommendationTarget(data, selected) {
      const deviceIndex=data.options.indexOf('Device');
      const matches=data.variants.filter(v=>this.normalize(v.options[deviceIndex])===this.normalize(selected.option1));
      const targetType=data.options.indexOf('Case Type'), targetColor=data.options.indexOf('Color');
      const exact=matches.find(v=>(targetType<0||v.options[targetType]===selected.options[this.caseIndex])&&(targetColor<0||v.options[targetColor]===selected.options[this.colorIndex]));
      const sameType=matches.find(v=>targetType<0||v.options[targetType]===selected.options[this.caseIndex]);
      return {variant:exact||sameType||matches[0],changed:!exact && matches.length>0};
    }
    updateRecommendations() {
      if(!this.recommendationData || !this.nativeCombined || !this.chosen || this.pending || this.failed || !this.variant)return;
      const selected=this.variant, incoming=new URL(location.href);
      for(const card of document.querySelectorAll('[data-smd-recommendations] product-card')) {
        const script=card.querySelector('[data-smd-recommendation-variants]');if(!script)continue;
        let data=this.recommendationData.get(script);
        if(!data){try{data=JSON.parse(script.textContent);this.recommendationData.set(script,data);}catch{continue;}}
        const match=this.recommendationTarget(data,selected);
        card.hidden=!match.variant;
        if(!match.variant)continue;
        for(const link of card.querySelectorAll('a[href]')) {
          const url=new URL(link.getAttribute('href'),location.origin);
          if(url.origin!==location.origin || !url.pathname.includes('/products/'))continue;
          url.searchParams.set('smd_device',selected.option1);
          if(match.variant)url.searchParams.set('variant',match.variant.id);else url.searchParams.delete('variant');
          if(match.changed)url.searchParams.set('smd_selection_changed','1');else url.searchParams.delete('smd_selection_changed');
          for(const [key,value] of incoming.searchParams)if(key==='preview_theme_id'||key.startsWith('utm_')||key==='gclid'||key==='fbclid')url.searchParams.set(key,value);
          const href=url.pathname+url.search+url.hash;if(link.getAttribute('href')!==href)link.setAttribute('href',href);
        }
      }
      for(const root of document.querySelectorAll('[data-smd-recommendations]')){
        const cards=[...root.querySelectorAll('product-card')];
        root.hidden=cards.length>0 && cards.every(card=>card.hidden);
      }
    }
    get form() {return document.getElementById(this.formId);}
    get variant() {return this.variants.find(v => String(v.id) === String((this.nativeCombined ? this.selectedVariantId : null) || this.form?.querySelector('[name="id"]')?.value));}
    selectedOptions() {
      return [...document.querySelectorAll(`input[data-option-position][form="${this.formId}"]:checked`)]
        .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition))
        .map(radio=>radio.dataset.optionName || radio.closest('label')?.textContent.trim() || document.querySelector(`label[for="${radio.getAttribute('id')}"]`)?.textContent.trim());
    }
    caseType(v=this.variant){
      if(!this.nativeCombined)return this.dataset.caseType;
      const value=String(v?.options[this.caseIndex]||'').toLowerCase();
      return value.includes('grain')?'GRAIN':value.includes('carbon')?'CARBON [S1]':value.includes('slim')?'SLIM [S2]':'';
    }
    caseLabel(v=this.variant){return this.caseType(v)==='GRAIN'?'LEATHER X':this.caseType(v).split(' [')[0];}
    mediaDevice(alt){
      return String(alt||'').match(/\b(iPhone\s+(?:\d+(?:\s+(?:Pro Max|Pro|Air|Plus))?|Xs?\s*max)|Samsung\s+S\d+\s+Ultra)\b/i)?.[1] || '';
    }
    updateSlimPreview(v){
      for(const type of ['SLIM','CARBON']){
        const frame=this.querySelector(`[data-native-case-preview="${type}"]`),image=frame?.querySelector('img');
        if(!image)continue;
        const color=type==='CARBON'?'Black':(this.caseType(v)==='SLIM [S2]'?v.options[this.colorIndex]:(this.slimColor||'Black'));
        const candidates=this.variants.filter(c=>String(c.options[this.caseIndex]).toUpperCase().includes(type)&&c.options[this.colorIndex]===color);
        const hasImage=c=>!!(c.featured_media?.preview_image?.src||c.featured_image?.src);
        const preview=candidates.find(c=>this.normalize(c.option1)===this.normalize(v.option1)&&hasImage(c))||candidates.find(hasImage);
        const source=preview?.featured_media?.preview_image?.src||preview?.featured_image?.src;
        frame.hidden=!source;if(!source)continue;
        const url=new URL(source,location.origin);url.searchParams.set('width','480');
        if(image.getAttribute('src')!==url.toString()){image.removeAttribute('srcset');image.setAttribute('src',url.toString());image.setAttribute('sizes','160px');}
        image.alt=preview.featured_media?.alt||`${type} reference case — ${color}`;
        frame.dataset.casePreviewVariant=preview.id;frame.dataset.casePreviewDevice=preview.option1;frame.dataset.casePreviewColor=color;
      }
    }
    mediaGroup(media){
      const image=media.querySelector('img');
      const filename=String(image?.currentSrc||image?.src||'').split('?')[0].split('/').pop().toUpperCase();
      // The source filenames carry construction/color even when descriptive alt wording varies.
      if(filename.includes('_GRAIN_'))return 'grain';
      if(filename.includes('_CARBON_S1_'))return 'carbon';
      if(filename.includes('_SLIM_S2_')){
        const body=filename.split('_SLIM_S2_')[1];
        return body.match(/(?:^|_)(ORANGE|GRAY|GREY|BLACK)(?:_|\.)/)?.[1].toLowerCase().replace('grey','gray')||'black';
      }
      const alt=String(image?.alt||'').toLowerCase();
      if(/\b(?:grain|leather\s*x)(?: series)? case\b/.test(alt))return 'grain';
      if(/\bcarbon(?:\s*\[?s1\]?)?(?:\s+black)? case\b/.test(alt))return 'carbon';
      const color=alt.match(/\bslim(?:\s*\[?s2\]?)?\s+(black|gray|grey|orange)\b/)?.[1]||alt.match(/\b(black|gray|grey|orange)\s+slim(?:\s*\[?s2\]?)? case\b/)?.[1];
      return color?.replace('grey','gray');
    }
    filterGallery(v){
      const gallery=this.querySelector('product-gallery');
      if(!gallery || !customElements.get('media-carousel') || !gallery._onVariantChanged)return;
      const group=this.caseType(v)==='GRAIN'?'grain':this.caseType(v)==='CARBON [S1]'?'carbon':String(v.options[this.colorIndex]).toLowerCase();
      const signature=group+'|'+this.normalize(v.option1);
      if(this.galleryGroup===signature)return;
      this.displayMedia=null;
      const media=[...gallery.querySelectorAll('.product-gallery__media')];
      const classified=media.map(m=>({group:this.mediaGroup(m),device:this.mediaDevice(m.querySelector('img')?.alt||'')}));
      const matches=classified.map((m,i)=>m.group===group?i:-1).filter(i=>i>=0);
      if(!matches.length)return;
      const exact=matches.filter(i=>classified[i].device&&this.normalize(classified[i].device)===this.normalize(v.option1));
      let allowed=exact,reference='';
      // ASTRO launch: include the approved shared detail views with each exact-size main.
      const astroIds=["9075375833278","9075376029886","9075376193726","9075376423102","9075376619710","9075376783550","9075376947390","9075377176766"];
      if(exact.length && astroIds.includes((this.formId||'').match(/^product-form-(\d+)-/)?.[1])){
        const shared=matches.filter(i=>/\bview\s+[2-7]\b/i.test(media[i].querySelector('img')?.alt||''));
        allowed=[...new Set([...exact,...shared])].sort((a,b)=>a-b);
      }
      if(!exact.length){
        reference=this.mediaDevice(v.featured_media?.alt)||classified[matches[0]].device;
        allowed=matches.filter(i=>!classified[i].device||this.normalize(classified[i].device)===this.normalize(reference));
      }
      if(!allowed.length)allowed=[matches[0]];
      const filteredIndexes=media.map((m,i)=>allowed.includes(i)?-1:i).filter(i=>i>=0);
      gallery.setAttribute('filtered-indexes',JSON.stringify(filteredIndexes.map(i=>i+1)));
      gallery.querySelectorAll('media-carousel').forEach(c=>c.dispatchEvent(new CustomEvent('carousel:filter',{detail:{filteredIndexes}})));
      gallery.querySelectorAll('page-dots').forEach(c=>c.dispatchEvent(new CustomEvent('control:filter',{detail:{filteredIndexes}})));
      const chosen=allowed.find(i=>String(media[i].dataset.mediaId)===String(v.featured_media?.id))??allowed[0];
      this.displayMedia={id:Number(media[chosen].dataset.mediaId),position:chosen+1};
      gallery._onVariantChanged({detail:{variant:{...v,featured_media:this.displayMedia},previousVariant:null}});
      this.galleryGroup=signature;
    }
    selectNative(e){
      const before=this.variant;
      if(Number(e.target.dataset.optionPosition)===1)this.chosen=true;
      let options=before?.options.slice() || this.selectedOptions();
      options[Number(e.target.dataset.optionPosition)-1]=e.target.dataset.optionName;
      const singleColor=/carbon|grain/i.test(String(options[this.caseIndex]));
      const colorRadios=[...this.querySelectorAll(`input[data-option-position="${this.colorIndex+1}"]`)];
      if(singleColor){
        if(this.caseType(before)==='SLIM [S2]')this.slimColor=before.options[this.colorIndex];
        // Resolve the actual single body color; never borrow a Slim color or change the device.
        const match=this.variants.find(v=>v.options.every((o,i)=>i===this.colorIndex||o===options[i]));
        if(match){options[this.colorIndex]=match.options[this.colorIndex];const color=colorRadios.find(r=>r.dataset.optionName===options[this.colorIndex]);if(color)color.checked=true;}
      }
      else if(Number(e.target.dataset.optionPosition)===this.caseIndex+1 && this.slimColor){
        const candidate=options.slice();candidate[this.colorIndex]=this.slimColor;
        if(this.variants.some(v=>v.options.every((o,i)=>o===candidate[i]))){options=candidate;const color=colorRadios.find(r=>r.dataset.optionName===this.slimColor);if(color)color.checked=true;}
      }
      const variant=this.variants.find(v=>v.options.every((o,i)=>o===options[i]));
      this.requested=options;this.pending=false;this.failed=!variant;
      if(!variant){this.message('This combination is unavailable. Choose another option.',true);this.update();return;}
      if(this.caseType(variant)==='SLIM [S2]')this.slimColor=variant.options[this.colorIndex];
      this.selectedVariantId=variant.id;
      this.form.querySelector('[name="id"]').value=variant.id;
      const script=this.querySelector('[data-native-picker] script[data-variant]');if(script)script.textContent=JSON.stringify(variant);
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({path:url.toString()},'',url);
      this.filterGallery(variant);
      this.form.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{formId:this.formId,variant:{...variant,featured_media:this.displayMedia||variant.featured_media},previousVariant:before}}));
      this.message('');this.update();
      if(Number(e.target.dataset.optionPosition)===1)e.target.closest('x-popover')?.hide();
    }
    canBuy() {const v=this.variant;return this.chosen && !this.pending && !this.failed && !this.adding && !this.addUncertain && v?.available && v.options.every((o,i)=>o===this.selectedOptions()[i]) && (!this.requested || v.options.every((o,i)=>o===this.requested[i]));}
    message(text,error=false) {
      const el=this.querySelector('[data-case-message]');
      if(el){if(el.textContent!==text)el.textContent=text;el.toggleAttribute('data-error',error);}
    }
    edit() {this.querySelector('.product-info__variant-picker').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.querySelector('.variant-picker .select')?.focus({preventScroll:true});}
    updateStickyButton(text,ready,v) {
      const button=this.querySelector('[data-case-submit]');
      if(!button)return;
      button.disabled=!ready;
      const label=button.querySelector('[data-case-submit-label]') || button;
      if(label.textContent!==text)label.textContent=text;
      const price=this.querySelector('[data-case-price]');
      if(!price)return;
      price.hidden=!this.chosen || this.pending || this.failed || !v;
      if(v){
        const amount=this.moneyText(this.money[v.id]);
        const currency=price.dataset.currency;
        const value=currency && !amount.includes(currency) ? `${amount} ${currency}` : amount;
        if(price.textContent!==value)price.textContent=value;
      }
    }
    update() {
      const watchEl=this.querySelector('.product-info__buy-buttons');
      if(watchEl && this.watched!==watchEl && this.watch){this.watch.disconnect();this.watched=watchEl;this.watch.observe(watchEl);}
      const v=this.variant;
      if(this.nativeCombined && v){
        const hidden=this.form?.querySelector('[name="id"]');if(hidden&&String(hidden.value)!==String(v.id))hidden.value=v.id;
        for(const input of this.querySelectorAll('input[data-option-position]')){
          const checked=input.dataset.optionName===v.options[Number(input.dataset.optionPosition)-1];if(input.checked!==checked)input.checked=checked;
        }
      }
      const ready=this.canBuy();
      const text=this.addUncertain?'Check your cart':this.adding?'Adding…':this.pending?'Updating…':!this.chosen||this.failed?'Choose your device':!v?'Unavailable':!v.available?'Sold out':'Add to cart';
      const native=this.form?.querySelector('[type="submit"]');
      if(native){native.disabled=!ready;const label=native.querySelector(':scope > div') || native.querySelector('.button__text');if(label && label.textContent!==text)label.textContent=text;}
      this.updateStickyButton(text,ready,v);
      const summary=this.querySelector('[data-case-summary]');
      const caseType=this.caseType(v);
      const description=this.chosen && v ? (this.nativeCombined?v.option1:v.title+(caseType==='SLIM [S2]' && v.options.length===1?' · Black':'')) : 'Choose your device';
      if(summary.textContent!==description)summary.textContent=description;
      const colorLabel=this.querySelector('[data-case-color-label]');
      const colorText=this.chosen && this.nativeCombined && v && caseType==='SLIM [S2]' ? '· '+v.options[this.colorIndex] : '';
      if(colorLabel && colorLabel.textContent!==colorText)colorLabel.textContent=colorText;

      const checkCart=this.querySelector('[data-case-check-cart]');if(checkCart)checkCart.hidden=!this.addUncertain;
      const picker=this.querySelector('.variant-picker');
      const select=picker?.querySelector('.select span');
      if(!this.chosen && select && select.textContent!=='Choose your device')select.textContent='Choose your device';
      const deviceValue=picker?.querySelector('.variant-picker__option-info .h-stack > span');
      if(deviceValue)deviceValue.hidden=!this.chosen;
      const caseLabel=this.querySelector('[data-case-type-label]');if(caseLabel)caseLabel.textContent=this.caseLabel(v);
      if(this.nativeCombined && v){
        const colorField=this.querySelector('[data-option-field="Color"]');if(colorField)colorField.hidden=caseType!=='SLIM [S2]';
        let badgeList=this.querySelector('.product-info__badge-list');
        if(!badgeList){const priceBlock=this.querySelector('.product-info__price');if(priceBlock){badgeList=document.createElement('div');badgeList.className='product-info__badge-list';priceBlock.append(badgeList);}}
        let soldOut=badgeList?.querySelector('sold-out-badge');
        if(badgeList&&!soldOut){soldOut=document.createElement('sold-out-badge');soldOut.className='badge badge--sold-out';soldOut.textContent='Sold out';badgeList.append(soldOut);}
        if(soldOut)soldOut.hidden=!!v.available;
        for(const field of this.querySelectorAll('[data-option-label-position]')){const index=Number(field.dataset.optionLabelPosition)-1;const value=index===this.caseIndex?this.caseLabel(v):v.options[index];if(field.textContent!==value)field.textContent=value;}
        const select=picker.querySelector('.select span');const value=this.chosen?v.option1:'Choose your device';if(select && select.textContent!==value)select.textContent=value;
        for(const card of this.querySelectorAll('[data-native-case-card],[data-native-color]'))card.classList.toggle('is-selected',card.querySelector('input').checked);
        this.updateSlimPreview(v);
        for(const facts of this.querySelectorAll('[data-native-facts]'))facts.hidden=facts.dataset.nativeFacts!==caseType;
        this.filterGallery(v);
        const salePrice=this.querySelector('.product-info__price sale-price');const money=this.moneyText(this.money[v.id]);if(salePrice && salePrice.textContent!==money)salePrice.textContent=money;
      }
      for(const link of this.querySelectorAll('[data-case-link]')) {
        const data=JSON.parse(this.querySelector(`[data-case-product="${link.dataset.case}"]`).textContent);
        const url=new URL(data.url,location.origin);url.searchParams.set('view','combined-case');
        const currentURL=new URL(location.href);
        for(const [key,value] of currentURL.searchParams)if(key==='preview_theme_id'||key.startsWith('utm_')||key==='gclid'||key==='fbclid')url.searchParams.set(key,value);
        if(this.dataset.previewThemeId)url.searchParams.set('preview_theme_id',this.dataset.previewThemeId);
        if(this.chosen && v){
          const matches=data.variants.filter(candidate=>this.normalize(candidate.option1)===this.normalize(v.option1));
          const target=matches.find(candidate=>candidate.options.slice(1).join('|')===v.options.slice(1).join('|')) || matches.find(candidate=>candidate.option2==='Black') || matches[0];
          url.searchParams.set('smd_device',v.option1);
          if(target)url.searchParams.set('variant',target.id);
        }
        if(link.getAttribute('href')!==url.pathname+url.search)link.setAttribute('href',url.pathname+url.search);
        link.setAttribute('aria-disabled',String(this.pending));
      }
      this.updateRecommendations();
      this.dataset.ready='true';
    }
  });
}
